// MST
import { types } from 'mobx-state-tree'

// Interfaces
import { QUESTION_TYPES, QUESTION_LAYOUT } from 'constant/shared.constant'

// Helper
import { withHelper_fileUserWithIdStatusModel } from './file.helper'
import { withHelper_commonLoadingModel } from './common.helper'

// Types
const { optional, model, maybeNull, enumeration, array, string, boolean } = types

export const withHelper_answerOptionModel = model('AnswerOption').props({
  id: maybeNull(string),
  answerOptionType: maybeNull(enumeration('AnswerType', Object.values(QUESTION_TYPES))),
  label: maybeNull(string),
  value: maybeNull(string),
  isSelected: maybeNull(boolean),
})

export const withHelper_answerModel = model('Answer').props({
  answerCode: maybeNull(string),
  answerLayout: maybeNull(enumeration('AnswerLayout', Object.values(QUESTION_LAYOUT))),
  answerType: maybeNull(enumeration('AnswerType', Object.values(QUESTION_TYPES))),
  answerValue: maybeNull(string),
  answerFiles: optional(array(withHelper_fileUserWithIdStatusModel), []),
  answerOption: optional(array(withHelper_answerOptionModel), []),

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
})
